// src/Pages/Auth/SignUpZid.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import config from '../../config';

export default function SignUpSalla() {
  const [status, setStatus] = useState('loading');
  const [isNewUser, setIsNewUser] = useState(null);
  const [userStore, setUserStore] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) { setStatus('error'); return; }

    fetch(`${config.baseUrl}/salla/callback/`, {
      method: 'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ code }),
    })
    .then(res => {
      if (!res.ok) throw new Error('Callback failed');
      return res.json();
    })
    .then(data => {
      if (data.status !== 'success') throw new Error('Backend error');
      setIsNewUser(data.is_new);
      setUserStore({ user: data.user, store: data.store });
      setStatus('success');

      setTimeout(() => {
        if (data.is_new) {
          navigate('/auth/signup/onboarding/zid', {
            state: { user: data.user, store: data.store }
          });
        } else {
          navigate('/user/chatbot');
        }
      }, 1500);
    })
    .catch(err => {
      console.error(err);
      setStatus('error');
    });
  }, [navigate]);

  const variants = { hidden:{opacity:0,y:20}, visible:{opacity:1,y:0}, exit:{opacity:0,y:-20} };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <AnimatePresence mode="wait">
        {status==='loading' && (
          <motion.div key="loading" initial="hidden" animate="visible" exit="exit" variants={variants}>
            <p className="text-xl font-semibold">Authorizing with Zid...</p>
          </motion.div>
        )}
        {status==='success' && (
          <motion.div key="success" initial="hidden" animate="visible" exit="exit" variants={variants}>
            <h1 className="text-2xl font-bold text-green-600">✅ Success!</h1>
            <p>Redirecting you to {isNewUser ? 'onboarding' : 'dashboard'}…</p>
          </motion.div>
        )}
        {status==='error' && (
          <motion.div key="error" initial="hidden" animate="visible" exit="exit" variants={variants}>
            <h1 className="text-2xl font-bold text-red-600">❌ Login Failed</h1>
            <p>Please try again later.</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
